import Swiper from 'swiper';
import { Navigation, Grid } from 'swiper/modules';

class TvsGalleryGrid extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const swiper = new Swiper(this, {
            // Optional parameters
            modules: [Navigation, Grid],
            navigation: {
                nextEl: ".button-next",
                prevEl: ".button-prev",
            },
            grid: {
                rows: 1,
                fill: "row",
            },
            loop: false,
            breakpoints: {
                640: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                    grid: {
                        rows: 3,
                        fill: "row",
                    },
                },
                1110: {
                    slidesPerView: 2,
                    spaceBetween: 40,
                    grid: {
                        rows: 3,
                        fill: "row",
                    },
                },
            },
            on: {
                init: function () {
                    var maxHeight = 0;

                    function getDivHeight(selector) {
                        const elements = document.querySelectorAll(selector);
                        let maxHeight = 0;
                        elements.forEach(element => {
                            maxHeight = Math.max(maxHeight, element.offsetHeight);
                        });
                        return maxHeight;
                    }

                    function setDivHeight(selector) {
                        const elements = document.querySelectorAll(selector);
                        const maxHeight = getDivHeight(selector);
                        elements.forEach(element => {
                            element.style.height = `${maxHeight}px`;
                        });
                    }

                    setDivHeight('.description');
                },
            },
        });
    }
}

customElements.define('tvs-gallery-grid', TvsGalleryGrid);